<template>
  <div class="summary-header flex-grow-1">
    <div v-if="hasPayment">
      <div class="d-lg-none" ref="mobileDetect"></div>
      <div v-if="!isMobile()">
        <AlertList/>
        <b-container v-if="hasPayment">
          <h1 class="mt-0 py-9">Resumo da sua conta</h1>
          <b-row
            id="paymentInformationDash"
            class="justify-content-between payment-information"
          >
            <b-col class="col-12" v-if="isUnic">
              <BalanceCardUnique />
            </b-col>
            <b-col
              v-if="!!this.$slots.left && !isUnic"
              class="left-card-desktop"
            >
              <slot name="left"></slot>
            </b-col>
            <b-col
              v-if="!!this.$slots.right && !isUnic"
              class="right-card-desktop"
            >
              <slot name="right"></slot>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div v-if="isMobile()">
        <AlertList/>
        <h1 class="mt-0 py-9 text-center">Resumo da sua conta</h1>
        <b-col class="col-12 pb-3" v-if="isUnic">
          <BalanceCardUnique />
        </b-col>
        <carousel
          v-if="!this.isUnic"
          :items="1"
          :stagePadding="30"
          :nav="false"
          :margin="15"
          class="pb-5"
        >
          <div v-if="!!this.$slots.left" class="d-flex flex-column flex-grow-1">
            <slot class="col-8" name="left"></slot>
          </div>
          <div
            v-if="!!this.$slots.right"
            class="d-flex flex-column flex-grow-1"
          >
            <slot class="col-8" name="right"></slot>
          </div>
        </carousel>
      </div>
    </div>
    <div class="loading-placeholder" v-if="!hasPayment">
      <b-container>
        <h1 class="mt-0 py-9 text-center">Carregando Resumo...</h1>
      </b-container>
    </div>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel';
import { mapGetters } from 'vuex';
import BalanceCardUnique from '@/components/BalanceCardUnique';
import paymentFilter from '@/utils/filterUtils';
import AlertList from '@/components/AlertList';
import { isMobile } from '@/utils/mobileUtils';

export default {
  name: 'DashboardSummaryHeader.vue',
  components: {
    carousel,
    BalanceCardUnique,
    AlertList,
  },
  methods: {
    checkMobile(size) {
      return window.innerWidth <= size;
    },
    isMobile() {
      return isMobile();
    },
  },
  computed: {
    ...mapGetters(['payments', 'currentBalance', 'enabledFeatures']),
    isUnic() {
      return (
        this.payments.length === 0 || paymentFilter(this.payments).length === 0
      );
    },
    hasPayment() {
      return this.currentBalance.value !== null;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/setup/_variables.scss";

.container {
  font-family: $font-1;
  padding: 0 0 30px;
}

.payment-information {
  margin: initial;
}

.left-card-desktop,
.right-card-desktop {
  padding: initial;
  flex: 0 0 49.5%;
}

.summary-header {
  background-color: #f19740;
}
h1 {
  color: white;
  text-align: left;
}

@media screen and (max-width: $sm) {
  h1 {
    font-size: $font-size-small;
  }
}
.alert-mobile-row {
  margin-left: 8px;
  margin-right: 8px;
}

.link-faq-payment {
  font-family: UOLtext;
  font-size: 13px;
  color: #ffffff;
  text-decoration: none;
}

.link-faq-payment:hover {
  text-decoration: underline;
}
</style>

<style>
.owl-carousel .owl-stage {
  display: flex;
  padding: 0 5% !important;
}

.owl-carousel .owl-item {
  display: flex;
}
</style>
